const SHOW = { all: "", sm: "hidden sm:block", md: "hidden md:block" };
const FLOAT = { a: "pf-float", b: "pf-float-slow" };

/**
 * A glass card that floats in front of a PhoneStage. The outer box sits at its own depth `z` (px), so it shifts against the phone as the
 * pointer moves; the middle one pops in (`delay` ms, left out for no entrance); the inner one bobs (`float` "a" or "b", or null for still).
 * `position` is Tailwind classes (left/top...): keep the overhang past the phone small (use the CHIP_L / CHIP_R sizes below, which are a fraction of the
 * window width) so a card never leaves the window and makes the page scroll sideways. Decorative, so hidden from screen readers.
 * From lg up the card is bigger (15 px title, 13 px line, 22 px icon): on a laptop the phone is a long way from the reader.
 */
export const CHIP_L = "-left-[clamp(0.5rem,3.5vw,6rem)]";
export const CHIP_R = "-right-[clamp(0.5rem,3.5vw,6rem)]";

export default function FloatingChip({ icon: Icon, title, sub, z = 60, float = "a", position = "", showOn = "all", delay, className = "" }) {
  return (
    <div className={`absolute pointer-events-none w-max max-w-[min(16rem,calc(100vw-2rem))] lg:max-w-[19rem] transition-opacity duration-300 ${SHOW[showOn] ?? ""} ${position} ${className}`} style={{ transform: `translateZ(${z}px)` }} data-chip="true" aria-hidden="true">
      <div className={delay == null ? "" : "kit-pop"} style={delay == null ? undefined : { animationDelay: `${delay}ms` }}>
        <div className={`${FLOAT[float] || ""} glass flex items-center gap-2.5 lg:gap-3 rounded-2xl px-3 py-2 lg:px-4 lg:py-3 shadow-float`}>
          {Icon ? <span className="w-8 h-8 lg:w-11 lg:h-11 rounded-xl bg-lime-400/15 border border-lime-400/30 flex items-center justify-center shrink-0"><Icon className="w-4 h-4 lg:w-[22px] lg:h-[22px] text-lime-300" /></span> : null}
          <span className="leading-tight text-left"><span className="block text-[13px] lg:text-[15px] font-bold text-white">{title}</span>{sub ? <span className="block text-[11px] lg:text-[13px] text-zinc-400 mt-0.5">{sub}</span> : null}</span>
        </div>
      </div>
    </div>
  );
}
